import {Box, Typography, styled} from '@mui/material';

const StyledSpecialtiesGrid = styled(Box)`
	display: grid;
	flex-wrap: wrap;
	grid-template-columns: 1fr;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('lg')} {
		column-gap: 24px;
		grid-template-columns: repeat(2, 1fr);
	}
`;

const StyledTypography = styled(Typography)`
	scroll-margin-top: 200px;
`;

export {StyledSpecialtiesGrid, StyledTypography};
